export const iconFontAwesomeAccessibilityAddressCard = (
	<i className="fa-solid fa-address-card"></i>
);
